module.exports = __webpack_public_path__ + "img/yiliao1-1.d2bfa86f.jpg";